// extracted by mini-css-extract-plugin
export default {"policy":"Policy_policy__8SqSq","title":"Policy_title__0mTt+","text":"Policy_text__TX6Dl"};